import { render, staticRenderFns } from "./SampleSelectorWizard.vue?vue&type=template&id=54c40590&scoped=true"
import script from "./SampleSelectorWizard.vue?vue&type=script&lang=ts"
export * from "./SampleSelectorWizard.vue?vue&type=script&lang=ts"
import style0 from "./SampleSelectorWizard.vue?vue&type=style&index=0&id=54c40590&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c40590",
  null
  
)

export default component.exports